import React from 'react';

const defaultVal = {} //Insert the default value here.
export const MainContext = React.createContext(defaultVal);